import { cx } from "shared/utils/classnames";
import type { FC, MouseEventHandler, ReactNode } from "react";
import { Link } from "react-router-dom";

interface CardProps {
  className?: string;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  linkTo?: string;
}

export const Card: FC<CardProps> = ({
  children,
  className,
  onClick,
  linkTo
}) => {
  const classNames = cx(
    "rounded-lg border border-alpha-100 bg-content-1000-inverted shadow-xs",
    onClick || linkTo
      ? "hover:border-alpha-200 hover:shadow-lg cursor-pointer"
      : "",
    className
  );

  if (linkTo)
    return (
      <Link to={linkTo} className={classNames}>
        {children}
      </Link>
    );

  return (
    <div className={classNames} onClick={onClick}>
      {children}
    </div>
  );
};
